<template>
  <div class="blacklist">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead /></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">姓名</div>
            <!-- @blur="getBlackList()" -->
            <el-input
              size="small"
              v-model="name"
              @keyup.enter.native="getBlackList()"
            ></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">身份证号</div>
            <el-input
              size="small"
              v-model="idcard"
              @keyup.enter.native="getBlackList()"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button
          type="text"
          @click="dropDownScreen"
          style="margin-right: 24px"
        >
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>

      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select
              v-model="strsrvcent"
              placeholder="请输入或选择"
              filterable
            >
              <el-option
                v-for="(item, index) in serviceList"
                :key="index"
                :label="item.StrSrvCent"
                :value="item.StrSrvCent"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>业务立项部门</div>
            <el-select
              v-model="strobjinstname"
              placeholder="请输入或选择"
              filterable
            >
              <el-option
                v-for="(item, index) in apartmentList"
                :key="index"
                :label="item.StrObjInstName"
                :value="item.StrObjInstName"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>项目名称</div>
            <el-input
              size="small"
              v-model="strobjname"
              placeholder="请输入项目名称"
            ></el-input>
          </div>
          <div class="formScreenInput">
            <div>负责客服</div>
            <el-input
              size="small"
              v-model="strusername"
              placeholder="请输入负责客服"
            ></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="resetHandle">
            清空
          </button>
          <button class="search" @click="getBlackList">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item>存档花名册</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="p_roster_table"
      >
        <!-- 招聘角色不能看雇员花名册 -->
        <el-tab-pane
          label="项目列表"
          name="项目列表"
          v-if="checkPermission(['customerList_tab_list'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="在职"
          name="在职"
          v-if="checkPermission(['customerList_tab_onjob'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职"
          name="离职"
          v-if="checkPermission(['customerList_tab_depart'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职转正"
          name="离职转正"
          v-if="
            checkPermission(['customerList_tab_transform'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="自离"
          name="自离"
          v-if="
            checkPermission(['customerList_tab_selfdepart'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="黑名单雇员"
          name="黑名单雇员"
          v-if="
            checkPermission(['customerList_tab_blacklist'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="导入导出记录"
          name="导入导出记录"
          v-if="
            checkPermission(['customerList_import'], permissionLists) ||
            checkPermission(['customerList_export'], permissionLists)
          "
        ></el-tab-pane>
      </el-tabs>
      <div class="blacklistTable">
        <el-table
          :data="tableData"
          :max-height="tableHeight - 180"
          border
          v-loading="listLoading"
        >
          <!-- <el-table-column type="selection" width="40"></el-table-column> -->
          <!-- <el-table-column fixed  align="center" prop="num" label="序号" width="60"></el-table-column> -->
          <el-table-column align="center" fixed label="序号" width="50">
            <template slot-scope="{ $index }">
              <span>{{
                (Number(currpage) - 1) * Number(pageSize) + Number($index) + 1
              }}</span>
            </template>
          </el-table-column>
          <template v-for="(item, index) in tableTitle">
            <el-table-column
              :prop="item.StrColumId"
              :label="item.StrColumName"
              fit
              show-overflow-tooltip
              :key="index"
              :width="
                item.StrColumName == '户籍地址' ||
                item.StrColumName == '现住地址' ||
                item.StrColumName == '参保日期' ||
                item.StrColumName == '签订合同起止时间记录' ||
                item.StrColumName == '备注'
                  ? 380
                  : item.StrColumName == '发薪公司全称'
                  ? 280
                  : 180
              "
              align="center"
              :fixed="
                item.StrColumName == '序号' ||
                item.StrColumName == '档案号' ||
                item.StrColumName == '姓名'
              "
              v-if="item.StrColumName != '序号'"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    item.StrColumName == '身份证有效终止时间' ||
                    item.StrColumName == '用工之日' ||
                    item.StrColumName == '试用期到期日期' ||
                    item.StrColumName == '劳动合同起始时间' ||
                    item.StrColumName == '劳动合同到期时间' ||
                    item.StrColumName == '离职日期' ||
                    item.StrColumName == '实际离职日期' ||
                    item.StrColumName == '工伤发生时间' ||
                    item.StrColumName == '工伤纠纷结束时间'
                  "
                >
                  {{
                    isNull(scope.row[item.StrColumId])
                      ? ""
                      : scope.row[item.StrColumId]
                  }}
                </div>
                <div v-else>{{ scope.row[item.StrColumId] }}</div>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="60"
            v-if="isCanHandle"
          >
            <template slot-scope="scope">
              <!-- <el-button type="text" size="small">查看</el-button>
              <el-button type="text" size="small" @click="deleteEmployee">移除</el-button>-->
              <el-dropdown trigger="click" @command="handleCommand(scope.row)">
                <span class="el-dropdown-link">
                  <img
                    src="../../assets/employee/images/more.png"
                    style="width: 14px; height: 16px; cursor: pointer"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item>
                    <img src="../../assets/employee/images/edit.png" class="editEmployee" />查看雇员信息
                  </el-dropdown-item> -->
                  <el-dropdown-item @click.native="Yblacklist(scope.row)">
                    <img
                      src="../../assets/employee/images/blacklist.png"
                      class="editEmployee"
                    />移出黑名单
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount > 0">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage3"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible10" width="30%">
      <div class="delTitle">确认移出黑名单</div>
      <div style="padding: 20px 20px 20px 0">
        请核对雇员信息：姓名{{
          "“" + this.emprow.StrEmpName + "”"
        }}、身份证号码{{ "“" + this.emprow.StrIdCard + "”" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="dialogVisible10 = false">取消</button>
        <button
          class="search"
          @click="confirmYBlack()"
          style="margin-left: 10px; font-weight: 600"
        >
          确定
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
import checkPermission from "@/utils/permission"; // 权限判断函数
export default {
  name: "blacklist",
  data() {
    return {
      tableHeight: 0,
      pagecount: 10,
      listLoading: false,
      bdate: "",
      edate: "",
      dates: [],
      pageSize: 10,
      workstatus: "",
      emprow: "",
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      dialogVisible10: false,
      name: "",
      idcard: "",
      strsrvcent: "",
      strobjinstname: "",
      strobjname: "",
      strusername: "",
      select: "",
      dialogVisible3: false,
      totalcount: 0,
      currpage: 1,
      currentPage3: 1,
      //下拉筛选
      showDropScreen: -1,
      tableData: [],
      //表头内容
      tableTitle: [],
      // 按钮权限参数
      butQuery: {
        path: "/customerList",
        powerEnName: "projectManage",
      },
      permissionLists: [], //按钮权限列表
      // 是否有权限操作按钮
      isCanHandle: false,
      activeName: "",
      //角色类型
      roleType: "",
    };
  },
  created() {
    this.roleType = localStorage.loginRoletype;
    this.getButtonPower();
    this.calHeight();
    this.getServiceList();
    this.getApartmentList();
  },
  mounted() {},
  methods: {
    checkPermission,
    //获取表头信息
    getImportFiledList() {
      const dataFiled = {
        pagecount: 1000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed: "all",
      };
      xz.getImportFiledInfo(dataFiled).then((res) => {
        if (res && res.data.length > 0) {
          try {
            res.data.forEach((element) => {
              if (element.StrColumName == "身份证号码") {
                let a1 = {
                  StrColumId: "idcardJudge",
                  StrColumName: "判定",
                };
                let a2 = {
                  StrColumId: "sex",
                  StrColumName: "性别",
                };
                let a3 = {
                  StrColumId: "birth",
                  StrColumName: "出生年月",
                };
                let a4 = {
                  StrColumId: "age",
                  StrColumName: "年龄",
                };
                res.data.splice(element.IntOrderId + 1, 0, a1, a2, a3, a4);
                this.tableTitle = res.data;
                throw new Error("ending");
              }
            });
          } catch (e) {
            if (e.message != "ending") throw e;
          }
          this.tableTitle = res.data;
          this.getBlackList();
        } else {
          this.tableTitle = [];
        }
      });
    },
    //切换tab
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == "项目列表") {
        this.$router.push({
          path: "/customerList",
          query: {
            currname: "项目列表",
          },
        });
      } else if (
        tab.name == "在职" ||
        tab.name == "离职" ||
        tab.name == "离职转正" ||
        tab.name == "自离"
      ) {
        this.$router.push({
          path: "/customerList",
          query: {
            currname: tab.name,
          },
        });
      } else {
        if (tab.name == "黑名单雇员") {
          this.getImportFiledList();
        }
        if (tab.name == "导入导出记录") {
          this.$router.push({
            path: "/operationRecord",
            query: {
              currname: "导入导出记录",
            },
          });
        }
      }
    },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height',this.tableHeight)
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      );
    },
    // 获取按钮权限
    getButtonPower() {
      let that = this;
      let param = this.$route.query.currname;
      xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
        // console.log('按钮',res)
        if (res.status == "ok") {
          let resmsg = res.msg;
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if (!this.isNull(param)) {
              this.activeName = param;
              that.getImportFiledList();
            } else {
              if (
                that.checkPermission(
                  ["customerList_tab_blacklist"],
                  permissionLists
                )
              ) {
                this.activeName = "黑名单雇员";
                that.getImportFiledList();
              }
            }
          } else {
            this.permissionLists = [];
            this.activeName = "";
          }
        } else {
          this.permissionLists = [];
          this.activeName = "";
        }
      });
    },
    //清空
    resetHandle() {
      this.strsrvcent = "";
      this.strobjinstname = "";
      this.strobjname = "";
      this.strusername = "";
      this.pagecount = window.localStorage.getItem("page")
        ? window.localStorage.getItem("page")
        : 10;
    },
    chooseDate() {
      // console.log('l',this.dates)
      this.bdate = this.dates[0];
      this.edate = this.dates[1];
    },
    handleCurrentChange(val) {
      this.currpage = `${val}`;
      this.currentPage3 = val;
      this.getBlackList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagecount = `${val}`;
      this.pageSize = parseInt(val);
      this.getBlackList();
    },
    clear() {
      this.name = "";
      this.idcard = "";
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstAllList().then((res) => {
        // console.log("getServeList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname });
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName });
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    },
    handleCommand(command) {
      if (command == "deleteEmployee") {
        this.dialogVisible3 = true;
      }
    },
    //移出黑名单
    Yblacklist(row) {
      this.emprow = row;
      this.dialogVisible10 = true;
    },
    //确认移出
    confirmYBlack() {
      const data = {
        fileno: this.emprow.StrFileNo,
        blacklistreason: "",
        blackstatus: "否",
      };
      xz.blacklistEmp(data).then((res) => {
        if (res) {
          this.$message({
            message: "移出黑名单成功",
            type: "success",
          });
          this.dialogVisible10 = false;
          this.emprow = "";
        } else {
          this.$message.error("系统异常，请于管理员联系");
          this.dialogVisible10 = false;
          this.emprow = "";
        }
        this.getBlackList();
      });
    },

    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    getBlackList() {
      this.listLoading = true;
      const data = {
        username: this.name,
        idcard: this.idcard,
        // strworkstate:this.workstatus,
        // dtentrybdatestart:this.bdate,
        // dtentrybdateend:this.edate,
        strsrvcent: this.strsrvcent,
        strobjinstname: this.strobjinstname,
        strobjname: this.strobjname,
        strusername: this.strusername,
        pagecount: this.pagecount,
        currpage: this.currpage,
      };
      xz.getBlackList(data).then((res) => {
        if (res.data && res.data.length > 0) {
          let i = 1 + (this.currpage - 1) * 10;
          res.data.forEach((l) => {
            l.DtEntryBdate
              ? (l.DtEntryBdate = l.DtEntryBdate.substring(0, 10))
              : "-";
            l.DtProbationEdate
              ? (l.DtProbationEdate = l.DtProbationEdate.substring(0, 10))
              : "-";
            l.DtContractBtime
              ? (l.DtContractBtime = l.DtContractBtime.substring(0, 10))
              : "-";
            l.DtContractTime
              ? (l.DtContractTime = l.DtContractTime.substring(0, 10))
              : "-";
            l.DtDepartureDate
              ? (l.DtDepartureDate = l.DtDepartureDate.substring(0, 10))
              : "-";
            l.DtRealDepartureDate
              ? (l.DtRealDepartureDate = l.DtRealDepartureDate.substring(0, 10))
              : "-";
            l.DtInjuryBdate
              ? (l.DtInjuryBdate = l.DtInjuryBdate.substring(0, 10))
              : "-";
            l.DtInjuryEdate
              ? (l.DtInjuryBdate = l.DtInjuryEdate.substring(0, 10))
              : "-";
            l.DtInsuranceDate ? (l.DtInsuranceDate = l.DtInsuranceDate) : "-";
            l.DtInjuryEdate
              ? (l.DtInjuryEdate = l.DtInjuryEdate.substring(0, 10))
              : "-";
            l["num"] = i++;
          });
          this.showDropScreen = -1;
          this.tableData = res.data;
          this.totalcount = parseInt(res.totalcount);
          //  this.clear();
        } else {
          this.showDropScreen = -1;
          this.tableData = [];
          this.totalcount = 0;
          // this.clear();
        }
        this.listLoading = false;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>


<style >
/* .table .el-table th {
  background-color: #ebfaf5;
  color: #303030;
} */
.p_roster_table.el-tabs--card {
  background-color: #fff;
}
.dropDownScreen .el-date-editor .el-range-separator {
  line-height: 24px;
}
.blacklistTable .el-table td {
  padding: 8px 0;
}
.blacklistTable .el-table th {
  padding: 10px 0;
}
.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  /* width: 300px; */
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-date-editor .el-range__icon {
  margin-top: 0;
}
</style>